import React, { useMemo } from 'react';
import { useI18n, useRootContext } from '@jarvis/react-portal-addons';
import {
  Container, Message, Subtitle, Title,
} from './styles';

export const ErrorPageContent = () => {
  const { t } = useI18n();
  const { properties: { invitationErrorPage, authzErrorPage } = {} } = useRootContext();

  const content = useMemo(() => {
    if (invitationErrorPage) {
      return {
        title: t('invitationErrorPage.title'),
        subtitle: t('invitationErrorPage.subtitle'),
        testId: 'invitation-error-page',
      };
    }

    if (authzErrorPage) {
      return {
        title: t('authzErrorPage.title'),
        subtitle: t('authzErrorPage.subtitle'),
        message: {
          text: t('authzErrorPage.message'),
          tagReplaceStart: `
          <a href="https://support.hp.com/us-en/document/ish_4995448-4995651-16?openCLC=true"
            target="_blank"
            rel="noopener noreferrer"
          >`,
          tagReplaceEnd: '</a>',
        },
        testId: 'authz-error-page',
      };
    }

    return {
      title: '',
      subtitle: '',
      testId: 'empty-error-page',
    };
  }, [authzErrorPage, invitationErrorPage, t]);

  return (
    <Container data-testid={content.testId}>
      <Title className="title-regular" data-testid="error-page-title">
        {content.title}
      </Title>

      <Subtitle className="body-large" data-testid="error-page-subtitle">
        {content.subtitle}
      </Subtitle>

      {content.message && (
        <Message
          className="title-regular"
          data-testid="error-page-message"
          {...content.message}
        />
      )}
    </Container>
  );
};

export default ErrorPageContent;
